import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import "./style.css";
import "./sidebar.css";

const Sidebar = () => {
  const navigate = useNavigate();

  const onShowViewFrequencyResponseFunctionClick = (axis) => {
    navigate(`/view-frequency-response-function/${axis}`);
  };

  const onShowAssembleVFRFClick = (axis) => {
    navigate(`/assemble-view-frequency-response-function/${axis}`);
  };
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const toggleSubMenu = (menu) => {
    setExpandedMenu(expandedMenu === menu ? null : menu);
  };

  const handleMouseEnter = (menu) => {
    setExpandedMenu(menu);
  };

  const handleMouseLeave = () => {
    setExpandedMenu(null);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 500) {
        setIsCollapsed(true);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={`sidebar-container ${isCollapsed ? "collapsed" : ""}`}>
      <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
        <button
          onClick={toggleSidebar}
          className="toggle-btn"
          aria-label={isCollapsed ? "展開側邊欄" : "收合側邊欄"}
        >
          {isCollapsed ? (
            <i className="bi bi-list" style={{ color: "Charcoal" }}></i>
          ) : (
            <i className="bi bi-bar-chart-steps"></i>
          )}
        </button>

        {!isCollapsed && (
          <ul className="sidebar-menu">
            <li
              className="sidebar-item"
              onMouseEnter={() => handleMouseEnter("機台資料庫")}
              onMouseLeave={handleMouseLeave}
            >
              <button className="sidebar-link" onClick={() => { toggleSubMenu("機台資料庫"); navigate('/machine-management'); }}>
                <i className="bi bi-database-fill"></i>
                機台資料庫
                <span className="icon">
                  {expandedMenu === "機台資料庫" ? <i className="bi bi-chevron-down"></i> : <i className="bi bi-chevron-right"></i>}
                </span>
              </button>
              {expandedMenu === "機台資料庫" && (
                <ul className="sub-menu">
                  <li className="sidebar-bg">
                    <button className="sidebar-link" onClick={() => onShowViewFrequencyResponseFunctionClick('x')}>
                      <i className="bi bi-clipboard-data"></i>
                      頻率響應函數-X軸
                    </button>
                  </li>
                  <li className="sidebar-bg">
                    <button className="sidebar-link" onClick={() => onShowViewFrequencyResponseFunctionClick('y')}>
                      <i className="bi bi-clipboard-data"></i>
                      頻率響應函數-Y軸
                    </button>
                  </li>
                  <li className="sidebar-bg">
                    <button className="sidebar-link" onClick={() => onShowViewFrequencyResponseFunctionClick('z')}>
                      <i className="bi bi-clipboard-data"></i>
                      頻率響應函數-Z軸
                    </button>
                  </li>
                </ul>
              )}
            </li>

            <li
              className="sidebar-item"
              onMouseEnter={() => handleMouseEnter("組裝資料庫")}
              onMouseLeave={handleMouseLeave}
            >
              <button className="sidebar-link" onClick={() => { toggleSubMenu("組裝資料庫"); navigate('/assemble-management'); }}>
                <i className="bi bi-database-fill"></i>
                組裝資料庫
                <span className="icon">
                  {expandedMenu === "組裝資料庫" ? <i className="bi bi-chevron-down"></i> : <i className="bi bi-chevron-right"></i>}
                </span>
              </button>
              {expandedMenu === "組裝資料庫" && (
                <ul className="sub-menu">
                  <li className="sidebar-bg">
                    <button className="sidebar-link" onClick={() => onShowAssembleVFRFClick('x')}>
                      <i className="bi bi-clipboard-data"></i>
                      頻率響應函數-X軸
                    </button>
                  </li>
                  <li className="sidebar-bg">
                    <button className="sidebar-link" onClick={() => onShowAssembleVFRFClick('y')}>
                      <i className="bi bi-clipboard-data"></i>
                      頻率響應函數-Y軸
                    </button>
                  </li>
                  <li className="sidebar-bg">
                    <button className="sidebar-link" onClick={() => onShowAssembleVFRFClick('z')}>
                      <i className="bi bi-clipboard-data"></i>
                      頻率響應函數-Z軸
                    </button>
                  </li>
                </ul>
              )}
            </li>

            <li
              className="sidebar-item"
              onMouseEnter={() => handleMouseEnter("鑄件資料庫")}
              onMouseLeave={handleMouseLeave}
            >
              <button className="sidebar-link" onClick={() => { toggleSubMenu("鑄件資料庫"); navigate('/casting-management'); }}>
                <i className="bi bi-database-fill"></i>
                鑄件資料庫
                <span className="icon">
                  {expandedMenu === "鑄件資料庫" ? <i className="bi bi-chevron-down"></i> : <i className="bi bi-chevron-right"></i>}
                </span>
              </button>
              {expandedMenu === "鑄件資料庫" && (
                <ul className="sub-menu">
                  <li className="sidebar-bg">
                    <button className="sidebar-link" onClick={() => navigate('/casting-view-frequency-response-function')}>
                      <i className="bi bi-clipboard-data"></i>
                      頻率響應函數
                    </button>
                  </li>
                </ul>
              )}
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default Sidebar;